import axios from "axios";
import ConsoleLocalStorage from "../storage/storage";
import { DEV_CONSOLE_URL } from "../config";

export default class DevConsoleAPI {
  instance = axios.create({
    baseURL: DEV_CONSOLE_URL,
    headers: {
      Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
    },
  });

  createOrganization(data) {
    return this.instance.post("organization", data);
  }

  updateOrganization(data){
    return this.instance.put("organization/" + ConsoleLocalStorage.getOrganization()?.id, data);
  }

  getOrganization(orgid) {
    return this.instance.get("organization/" + orgid);
  }
  getOrganizationWithToken() {
    return this.instance.get("organization/status",{
      headers: {
        Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      },
    });
  }
  updateOrg(orgid, data) {
    return this.instance.put("organization/" + orgid, data);
  }

  uploadKYC(data) {
    return this.instance.post("organization/upload-kyc", data, {
      headers: {
        "x-organization-id": ConsoleLocalStorage.getOrganization().id,
      },
    });
  }
}
